/**
 * 子级菜单出现动画
 * 
 */
"use strict";
angular.module("leftStartAniModule", []).
directive("leftstartani", ["$timeout", function($timeout) {
    return {
        restrict: 'A',
        replace: false,
        scope: false,
        link: function(scope, $elem, $attrs) {
            $timeout(function() {
                $elem.addClass('menu_start');
                scope.$emit("expandedThirdLevel", { expanded: true });
            }, 100);
            scope.$on("$destroy", function() {
                $elem.removeClass('menu_start');
                scope.$emit("expandedThirdLevel", { expanded: false });
            });
        }
    };
}]);